import { CreationTime } from "@/components/CreationTime";
import type { PlainPrompt } from "@/queries/prompt-queries";
import type { FC } from "react";

export const CommandCreatedAt: FC<{ command: PlainPrompt }> = ({ command }) => {
    return (
        <div className="text-xs text-content-secondary">
            Created <CreationTime timestamp={command.metadata?.createdAt} />
        </div>
    );
};
